import Axios from "../config/config";

//REPORTS API

export const COURSE_REPORT = async (body) => {
    try {
        const response = await Axios.post('course-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const PACKAGE_REPORT = async (body) => {
    try {
        const response = await Axios.post('package-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};




export const VIEW_LEARNER_REPORT = async (body) => {
    try {
        const response = await Axios.post('view-learner-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const QUIZ_REPORT= async (body) => {
    try {
        const response = await Axios.post('quiz-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LEARNER_QUIZ_REPORT= async (body) => {
    try {
        const response = await Axios.post('learner-quiz-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
